module.exports = __webpack_public_path__ + "img/fi-rr-money.5f77f9af.svg";